import React, { useContext } from "react";
import { PageLayout, useTranslator } from "@sia/style-guide";
import GlobalContext from "contexts/GlobalContext";
import SideBarWithLinks from "components/SideBarWithLinks";
import Page from "../Page";
import SurveySectionContent from "pages/SurveyPage/SectionContent/SurveySectionContent";
import { SurveyPageTop } from "./SurveyPageTop";
import { DataCollectionContext } from "contexts/DataCollectionContext";
import { SurveyFormSessionProvider } from "./SurveyFormSessionContext";
import "./DataCollection.scss";

const translationKeyPrefix = "benchmarking.data-collection-page";

/* eslint-disable react/prop-types */
const SurveyPage = () => {
  const { language: lang, survey } = useContext(GlobalContext);
  const translate = useTranslator();
  const pageTitle = translate(`${translationKeyPrefix}.title`);
  const { surveyConcluded } = useContext(DataCollectionContext);

  return (
    <Page className="data-collection" title={pageTitle}>
      <SurveyFormSessionProvider>
        {/* Page Top */}
        <PageLayout variant="layout_25_50_25">
          <div />
          <div className="center">
            <SurveyPageTop pageTitle={pageTitle} surveyYear={survey.surveyYear} deadline={survey.deadline} translate={translate} lang={lang} />
          </div>
          <div className={`right-column ${pageTitle.length > 39 ? "double-height-title" : ""}`}>
            <SideBarWithLinks />
          </div>
        </PageLayout>
        {/* Page Bottom */}
        <div id="section-scroll-anchor" className="invisible-when-mobile-width">
          {!surveyConcluded && <SurveySectionContent />}
        </div>

        <div className="invisible-when-full-width">
          <h3 className="sia-text-04">{translate("benchmarking.survey.footer.full-width.message")}</h3>
          <p className="sia-text-04">{translate("benchmarking.survey.footer.full-width.laptop")}</p>
        </div>
      </SurveyFormSessionProvider>
    </Page>
  );
};

export default SurveyPage;
